module.exports = __webpack_public_path__ + "img/Oval2.1c847f14.svg";